module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flow-new/menu-icon-action-4fd3ec8cb1d3c80540abc1f5607d120c.png";